import { ControlValueAccessor } from '@angular/forms';
import { Subject } from 'rxjs';
import { Util } from '@libs/utilities/util';


/**------------------------------------------------------
 * Abstract Input Component Definitions
 * ------------------------------------
 * > This abstract class defined the basic functions for
 * > the input components. All input components have to
 * > inherit from this abstract class. These functions
 * > can be overwritten in the child components.
 */
export class NgAbstractInputComponent<T> implements ControlValueAccessor {

	//** Static Helpers */
	private static idCounter = 0;		// static counter for unique id's

	//** Helper Variables */
	id			: string;
	value		: T | null = null;		// input value
	isDisabled !: boolean;
	onReady$	: Subject<void> = new Subject<void>();


	/**------------------------------------------------------
	 * Constrictor
	 */
	constructor(
		private componentName: string
	) {

		//0 - check if the component name is empty
		if (Util.String.isEmpty(componentName)) throw new Error(`AbstractInputComponent => constructor => FATAL ERROR: componentName of "${componentName}" can not be empty`);

		//1 - set the id value
		this.id = `${this.componentName}-${NgAbstractInputComponent.idCounter++}`;
	}


	/**------------------------------------------------------
	 * Control value accessor functions
	 */
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange  = (changedValue: T): void => {};
	onTouched = (): void => {};

	//** update value  */
	writeValue(value: T): void {
		this.value = value;
	}

	//** register on change */
	registerOnChange(fn: any): void {
		this.onChange = fn;
		this.onReady$.next();
	}

	//** register on touched */
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	//** set disabled state */
	setDisabledState?(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
